import React from "react";
import { Download, CheckSquare, Square } from "lucide-react";

/**
 * Floating action bar shown above admin tables when rows are selected.
 * Drives checkbox selection patterns across every admin surface.
 */
export default function BulkActionBar({
    totalVisible,
    selectedIds,
    onToggleSelectAll,
    onClear,
    onExportCsv,
    actions = [],   // [{ id, label, danger?, disabled?, onClick }]
    testidPrefix = "bulk",
}) {
    const count = selectedIds.length;
    const allSelected = totalVisible > 0 && count === totalVisible;

    return (
        <div
            data-testid={`${testidPrefix}-bar`}
            className="flex items-center justify-between gap-3 bg-midnight-pine text-white rounded-lg px-4 py-3 flex-wrap"
        >
            <div className="flex items-center gap-3">
                <button
                    data-testid={`${testidPrefix}-select-all`}
                    onClick={onToggleSelectAll}
                    className="flex items-center gap-2 text-sm font-bold hover:text-ember-orange"
                >
                    {allSelected ? (
                        <CheckSquare className="w-4 h-4" />
                    ) : (
                        <Square className="w-4 h-4" />
                    )}
                    {allSelected ? "Clear selection" : `Select all ${totalVisible}`}
                </button>
                <span
                    data-testid={`${testidPrefix}-count`}
                    className="text-xs font-semibold text-white/70 tabular-nums"
                >
                    {count} selected
                </span>
            </div>
            <div className="flex items-center gap-2 flex-wrap">
                {onExportCsv && (
                    <button
                        data-testid={`${testidPrefix}-export-csv`}
                        onClick={onExportCsv}
                        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-white/10 text-xs font-bold hover:bg-white/20"
                    >
                        <Download className="w-3.5 h-3.5" /> Export CSV
                    </button>
                )}
                {actions.map((a) => (
                    <button
                        key={a.id}
                        data-testid={`${testidPrefix}-action-${a.id}`}
                        disabled={a.disabled || count === 0}
                        onClick={a.onClick}
                        className={`px-3 py-1.5 rounded-md text-xs font-bold disabled:opacity-40 disabled:cursor-not-allowed ${
                            a.danger
                                ? "bg-ember-orange hover:bg-ember-dark"
                                : "bg-white/10 hover:bg-white/20"
                        }`}
                    >
                        {a.label}
                    </button>
                ))}
                <button
                    data-testid={`${testidPrefix}-clear`}
                    onClick={onClear}
                    className="text-xs font-bold text-white/70 hover:text-white px-2"
                >
                    Close
                </button>
            </div>
        </div>
    );
}
